/*
  Redesign PDP — "See all ingredients" link.
  The block's `link_url` is a `url` setting, so a bare section id ends up as a
  broken relative URL. This resolves the value flexibly to an on-page target
  (a raw element id, a section id, or a `#fragment`) and smooth-scrolls to it,
  accounting for the sticky header. Falls back to default navigation if no
  matching element is found. Scoped to the redesign section only.
*/
(() => {
  // Reserve space for the header only when it will actually cover the target.
  // A `on-scroll-up` sticky header hides while scrolling down, so scrolling
  // down to a section needs no offset; otherwise reserve the header height.
  const headerOffset = (scrollingDown) => {
    const sticky = document.querySelector('sticky-header');
    if (!sticky) return 0;
    if (scrollingDown && sticky.dataset.stickyType === 'on-scroll-up') return 0;
    return sticky.offsetHeight;
  };

  const resolveTarget = (raw) => {
    if (!raw) return null;
    const frag = raw.indexOf('#') !== -1 ? raw.slice(raw.indexOf('#') + 1) : raw.replace(/^\//, '');
    if (!frag) return null;
    return (
      document.getElementById(frag) ||
      document.getElementById('shopify-section-' + frag) ||
      null
    );
  };

  const onClick = (event) => {
    const target = resolveTarget(event.currentTarget.getAttribute('href'));
    if (!target) return; // unknown target — let the browser handle it
    event.preventDefault();
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const scrollingDown = targetTop > window.scrollY;
    const top = targetTop - headerOffset(scrollingDown);
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  };

  const init = () => {
    document
      .querySelectorAll('.main__product--redesign .featured-ingredients-link-anchor')
      .forEach((link) => link.addEventListener('click', onClick));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
